import BellIcon from '@heroicons/react/outline/esm/BellIcon.js'
import HomeIcon from '@heroicons/react/outline/esm/HomeIcon.js'
import LoginIcon from '@heroicons/react/outline/esm/LoginIcon.js'
import SearchIcon from '@heroicons/react/outline/esm/SearchIcon.js'
import UserCircleIcon from '@heroicons/react/outline/esm/UserCircleIcon.js'
import UserGroupIcon from '@heroicons/react/outline/esm/UserGroupIcon.js'
import ViewGridIcon from '@heroicons/react/outline/esm/ViewGridIcon.js'

import { SystemSpaceSlug } from '@tribeplatform/react-sdk/hooks'

export const SystemSpacesIcons = {
  [SystemSpaceSlug.HOME]: HomeIcon,
  [SystemSpaceSlug.SEARCH]: SearchIcon,
  [SystemSpaceSlug.NOTIFICATIONS]: BellIcon,
  [SystemSpaceSlug.PROFILE_SETTINGS]: UserCircleIcon,
  [SystemSpaceSlug.SIGNUP]: LoginIcon,
  [SystemSpaceSlug.LOGIN]: LoginIcon,
  [SystemSpaceSlug.ACCEPT_INVITATION]: LoginIcon,
  [SystemSpaceSlug.DIRECT_LOGIN]: LoginIcon,
  [SystemSpaceSlug.FORGOT_PASSWORD]: LoginIcon,
  [SystemSpaceSlug.JOIN_BY_INVITATION]: LoginIcon,
  [SystemSpaceSlug.RESET_PASSWORD]: LoginIcon,
  [SystemSpaceSlug.VERIFY_EMAIL]: LoginIcon,
  'default::members': UserGroupIcon,
  'default::spaces': ViewGridIcon,
}
